/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Email/Emails/Content/Email/Edit/Content/EditOrAdd/Content/EditAction",
  isSubmitting,
  onSubmit
  
}) {
let editEmailSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_email',
})
let editEmailIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_email',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="edit_email"
 disabled={editEmailIsSubmittingData}
 onClick={editEmailSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Edit Anyway"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}